import Vue from 'vue';
import tooltip from './rtTooltipGlobal';
import { debounce } from 'lodash';

let instance;
let targetClosestCount = 0;

const TooltipConstructor = Vue.extend(tooltip);

const initInstance = () => {
  instance = new TooltipConstructor({
    el: document.createElement('div')
  });
};

/**
 * 初始化全局tooltip
 */
function initTooltipGlobal () {
  if (!instance) {
    initInstance();
  }

  document.body.appendChild(instance.$el);

  document.addEventListener('mousemove', mousemoveHandler);

  Vue.nextTick(() => {
    // instance.visible = true;
  });
}

const mousemoveHandler = debounce((event) => {
  const target = event.target;
  targetClosestCount = 0;
  const targetTip = targetHasTip(target);
  if (targetTip) {
    instance.reference = targetTip;

    instance.visible = true;
  } else {
    instance.visible = false;
  }
}, 0);

const targetHasTip = (target) => {
  // 限制往上找父级元素的次数
  if (targetClosestCount > 5) {
    return false;
  }
  targetClosestCount++;
  if (target && target instanceof Element) {
    if (target.classList.contains('el-tooltip')) {
      return false;
    }

    if (target.hasAttribute('has-tip') && target.getAttribute('has-tip') !== 'false') {
      const items = target.querySelectorAll('*');

      // 如果有 tip-text 则认为需要强制展示其内容
      if (target.offsetWidth < target.scrollWidth || target.offsetHeight < target.scrollHeight || target.hasAttribute('tip-text')) {
        return target;
      }

      // 计算出父元素真实内容区域的宽高（去掉padding）和子元素的宽高
      const targetStyle = getComputedStyle(target);
      let targetTop = parseInt(targetStyle.paddingTop);
      targetTop = isNaN(targetTop) ? 0 : targetTop;
      let targetBottom = parseInt(targetStyle.paddingBottom);
      targetBottom = isNaN(targetBottom) ? 0 : targetBottom;
      let targetLeft = parseInt(targetStyle.paddingLeft);
      targetLeft = isNaN(targetLeft) ? 0 : targetLeft;
      let targetRight = parseInt(targetStyle.paddingRight);
      targetRight = isNaN(targetRight) ? 0 : targetRight;

      const targetRelHeight = target.offsetHeight - targetTop - targetBottom;
      const targetRelWidth = target.offsetWidth - targetLeft - targetRight;

      const hasTip = Array.from(items).some(item => {
        return (item.offsetHeight < item.scrollHeight || item.offsetWidth < item.scrollWidth || targetRelHeight < item.offsetHeight || targetRelWidth < item.offsetWidth)
      })

      if (hasTip) {
        return target;
      }
    }

    if (target.parentNode) {
      return targetHasTip(target.parentNode);
    }
  }
  return false;
}

export default initTooltipGlobal;

export { initTooltipGlobal };



// WEBPACK FOOTER //
// ./~/vue-xpc/src/components/tooltip/tooltipGlobal.js